import { useNavigate } from "react-router-dom";
import { useState } from "react";
import withLoader from "../../components/layouts/WithLoader";
import AlimentationCaisse from "../../components/finance/compteCaisse/AlimentationCaisse";

const AlimentationCaisseManagers = ({ startLoading, stopLoading }) => {
  const [caisseInfo, setCaisseInfo] = useState([]);
  const navigate = useNavigate();

  return (
    <>
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <div className="container-fluid">
          <AlimentationCaisse
            caisseInfo={caisseInfo}
            setCaisseInfo={setCaisseInfo}
          />
        </div>
      </div>
    </>
  );
};
export default withLoader(AlimentationCaisseManagers);
